import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/featured-trips-treks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/forms/get-in-touch-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/curated-destinations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/number-ticker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/offer-banner-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/special-categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/text-slide-animation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/trek-category.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/upcoming-trips-trek.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/image-loader.tsx");
